import { isBoolean } from '@tunasong/models'
import { NoteLib, ScaleLib } from '@tunasong/music-lib'
import type { FC } from 'react'
import { Note } from '../../note/note.js'
import type { NoteLabelProps } from './keyboard.js'
import styles from './label.module.css'

export const NoteLabel: FC<NoteLabelProps> = props => {
  const { note: providedNote, isAccidental, scale, label } = props
  const note = NoteLib.toNote(providedNote)
  const inScale = scale ? ScaleLib.noteInScale(scale, note) : undefined
  const renderDot = isBoolean(inScale) && label === 'note-scale'
  const renderLabel = label && label !== 'none'

  const dotColor =
    inScale === true
      ? 'var(--tuna-notes-inScale)'
      : inScale === false
        ? 'var(--tuna-notes-outOfScale)'
        : 'var(--tuna-notes-main)'

  return renderLabel ? (
    <div className={styles.labelContainer}>
      {renderDot ? (
        <div
          className={styles.dot}
          style={{
            backgroundColor: dotColor,
            alignSelf: isAccidental ? '' : 'center',
            left: isAccidental ? 2 : undefined,
          }}
        />
      ) : null}
      <Note
        note={note}
        scale={scale}
        className={styles.noteLabel}
        style={{
          /**
           * Black keys are dark in both themes, so their label is white. White keys are light in both (dimmed to grey in
           * dark), so their label is grey-900 in both: 6.01:1 dark, 14.78:1 light (GH #2557). Pressed or not: a pressed
           * key changes only its border, never its fill, so a pressed black key's label stays white (Joni, #2573)
           */
          color: isAccidental ? 'white' : 'var(--tuna-palette-grey-900)',
        }}
      />
    </div>
  ) : null
}
